import React from 'react';

import isHotkey from 'is-hotkey';
import { Transforms } from 'slate';
import { Editable, Slate } from 'slate-react';
import { Element } from './RichTextEditor.elements';
import { editor } from './RichTextEditor.resources';

const RichTextEditor = props => {
  const { onChange, initialValue } = props;

  return (
    <div className="bg-white p-3 rounded-xl border border-[#dde4de]">
      <Slate editor={editor} initialValue={initialValue} onChange={onChange}>
        <Editable
          className="!min-h-[20rem] bg-white focus:outline-none"
          onKeyDown={event => {
            if (isHotkey('mod+a', event)) {
              event.preventDefault();
              Transforms.select(editor, []);
            }
          }}
          renderElement={props => <Element {...props} />}
          placeholder="Enter some text..."
        />
      </Slate>
    </div>
  );
};

export default RichTextEditor;
